/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const reportOverviewCompanyInfoDtoSchema = z.object({
  geographyFlag: z.optional(z.string()),
  geography: z.optional(z.string()),
  size: z.optional(z.string()),
  foundersOwnershipPct: z.optional(z.int()),
});
